import { BaseModel } from "@blue-chip/core";

export default class Email extends BaseModel {}
